import { createContext, useMemo } from "react";
import { useAutoSelectProvidersByDefault } from "@RequestFormV2/sections/Provider/hooks/useAutoSelectProvidersByDefault";
import { useProviderData } from "@RequestFormV2/sections/Provider/context/useProviderData";
import { useProviderDefaultTimings } from "@RequestFormV2/sections/Provider/context/useProviderDefaultTimings";
import { useProviderHandlers } from "@RequestFormV2/sections/Provider/context/useProviderHandlers";

type ProviderContextType = ReturnType<typeof useProviderData> & ReturnType<typeof useProviderHandlers>;

const ProviderContext = createContext<ProviderContextType | null>(null);

function ProviderProvider({ children }: { children: React.ReactNode }) {
  const data = useProviderData();
  const handlers = useProviderHandlers({ allProvidersRequired: data.allProvidersRequired });

  useProviderDefaultTimings(data.timingSettings);
  useAutoSelectProvidersByDefault({
    providerOptions: data.providerOptions,
    minimumInvitesPossible: data.minimumInvitesPossible,
    defaultProvidersInvitation: data.defaultProvidersInvitation,
  });

  const value = useMemo(() => ({ ...data, ...handlers }), [data, handlers]);

  return <ProviderContext.Provider value={value}>{children}</ProviderContext.Provider>;
}

export { ProviderContext, ProviderProvider };
